import { render, staticRenderFns } from "./mrc_ess_paginationsWeb.vue?vue&type=template&id=3b0ed788&scoped=true&"
import script from "./mrc_ess_paginationsWeb.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_paginationsWeb.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_paginationsWeb.vue?vue&type=style&index=0&id=3b0ed788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ed788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemTitle,VMenu,VPagination})
